// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.annotation-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.15);
  z-index: 1050;
}
.annotation-container .container-header {
  padding: 0 4rem;
  color: white;
  background-color: black;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.annotation-container .container-header span {
  color: white;
}
.annotation-container .container-header .btn-link {
  color: white;
  font-size: 1rem;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.annotation-container .container-header .btn-link .close-icon {
  padding-left: 0.5rem;
}
.annotation-container .container-header .btn-link:hover {
  color: #aaa;
  text-decoration: none;
}
.annotation-container .container-header .btn-link:focus {
  box-shadow: none;
}
.annotation-container .container-body {
  padding: 1rem 4rem;
}
.annotation-container .container-body .color-picker-group {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 1rem;
}
.annotation-container .container-body .color-picker-group .form-label {
  margin-right: 1rem;
  flex-shrink: 0;
  margin-bottom: 0;
  color: black;
  font-weight: bold;
}
.annotation-container .container-body .color-picker-group .form-control[type=color] {
  height: 30px;
  width: 42px !important;
  border: 1px solid;
  border-radius: 50%;
  cursor: pointer;
  appearance: none;
  padding: 0;
  margin-right: 2rem;
}
.annotation-container .container-body .color-picker-group .form-control[type=color]::-webkit-color-swatch-wrapper {
  padding: 0;
}
.annotation-container .container-body .color-picker-group .form-control[type=color]::-webkit-color-swatch {
  border: none;
  border-radius: 50%;
}
.annotation-container .container-body .color-picker-group .form-control[type=color]::-moz-color-swatch {
  border: none;
  border-radius: 50%;
}
.annotation-container .container-body .form-control {
  border-radius: 0;
  border: 1px solid black;
  width: 70%;
}
.annotation-container .container-footer {
  padding: 1rem 4rem;
  display: flex;
  align-items: center;
  gap: 10px;
}
.annotation-container .container-footer .btn-primary {
  border-radius: 25px;
  background-color: #314CC6;
  border-color: #314CC6;
}
.annotation-container .container-footer .btn-secondary {
  border-radius: 25px;
  background-color: transparent;
  border: none;
  color: black;
}
.annotation-container .container-footer .btn-secondary:hover {
  color: red;
  border: 1px solid red;
}`, "",{"version":3,"sources":["webpack://./src/components/examComponents/AnnotationModal.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,2CAAA;EACA,aAAA;AADF;AAEE;EACE,eAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAGI;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADN;AAGM;EACE,oBAAA;AADR;AAIM;EACE,WAAA;EACA,qBAAA;AAFR;AAKM;EACE,gBAAA;AAHR;AAQE;EACE,kBAAA;AANJ;AAQI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AANN;AAQM;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AANR;AASM;EAEE,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EAEA,gBAAA;EACA,UAAA;EACA,kBAAA;AARR;AAUQ;EACE,UAAA;AARV;AAWQ;EACE,YAAA;EACA,kBAAA;AATV;AAYQ;EACE,YAAA;EACA,kBAAA;AAVV;AAgBI;EACE,gBAAA;EACA,uBAAA;EACA,UAAA;AAdN;AAkBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAhBJ;AAkBI;EACE,mBAAA;EACA,yBAAA;EACA,qBAAA;AAhBN;AAmBI;EACE,mBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;AAjBN;AAkBM;EACE,UAAA;EACA,qBAAA;AAhBR","sourcesContent":["// AnnotationModal.scss\n\n.annotation-container {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.15);\n  z-index: 1050; // To ensure it stays on top of other content\n  .container-header {\n    padding: 0 4rem;\n    color: white;\n    background-color: black;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    span {\n      color: white; // Ensure the text color is white for visibility\n    }\n\n    .btn-link {\n      color: white; // Make the close button white\n      font-size: 1rem; // Increase the size of the cross icon\n      text-decoration: none;\n      display: flex; // To align text and icon properly\n      justify-content: center;\n      align-items: center;\n\n      .close-icon {\n        padding-left: 0.5rem; // This adds space between the \"CLOSE\" text and the icon\n        // If using an actual icon font, you might need to adjust font-family and content here\n      }\n      &:hover {\n        color: #aaa; // Lighten the color slightly on hover for a feedback effect\n        text-decoration: none; // Remove underline from close button on hover\n      }\n\n      &:focus {\n        box-shadow: none; // Remove the focus outline on the close button\n      }\n    }\n  }\n\n  .container-body {\n    padding: 1rem 4rem; // Adding padding on both sides\n\n    .color-picker-group {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      margin-bottom: 1rem;\n\n      .form-label {\n        margin-right: 1rem;\n        flex-shrink: 0;\n        margin-bottom: 0;\n        color: black;\n        font-weight: bold;\n      }\n\n      .form-control[type=\"color\"] {\n        // Your provided styles\n        height: 30px;\n        width: 42px !important;\n        border: 1px solid;\n        border-radius: 50%;\n        cursor: pointer;\n        -webkit-appearance: none;\n        appearance: none;\n        padding: 0;\n        margin-right: 2rem; // Space after the color picker\n\n        &::-webkit-color-swatch-wrapper {\n          padding: 0;\n        }\n\n        &::-webkit-color-swatch {\n          border: none;\n          border-radius: 50%;\n        }\n\n        &::-moz-color-swatch {\n          border: none;\n          border-radius: 50%;\n        }\n      }\n    }\n\n    // Styles for text area\n    .form-control {\n      border-radius: 0; // Remove border-radius\n      border: 1px solid black; // Black border\n      width: 70%; // Adjust width\n    }\n  }\n\n  .container-footer {\n    padding: 1rem 4rem; // Equal padding as the header and body\n    display: flex; // Align buttons to the sides\n    align-items: center;\n    gap: 10px;\n\n    .btn-primary {\n      border-radius: 25px;\n      background-color: #314CC6; // Make the save button 314CC6\n      border-color: #314CC6; // Border color for consistency\n    }\n\n    .btn-secondary {\n      border-radius: 25px;\n      background-color: transparent; // Remove any background\n      border: none; // Remove border\n      color: black; // Text color black\n      &:hover {\n        color: red; // Text color red on hover\n        border: 1px solid red; // Add red border on hover\n      }\n    }\n  }\n\n  // Adapt the existing styles for your inputs and buttons accordingly\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
